import { render, staticRenderFns } from "./side-image.vue?vue&type=template&id=ef39ebbc&"
import script from "./side-image.vue?vue&type=script&lang=js&"
export * from "./side-image.vue?vue&type=script&lang=js&"
import style0 from "./side-image.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports